import { render } from "./turnover.vue?vue&type=template&id=20f78f93&scoped=true"
import script from "./turnover.vue?vue&type=script&lang=js"
export * from "./turnover.vue?vue&type=script&lang=js"

import "./turnover.vue?vue&type=style&index=0&id=20f78f93&scoped=true&lang=css"

import exportComponent from "/usr/src/old_admin_etchite_latest_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20f78f93"]])

export default __exports__